import React, { Component } from "react";
import { SetupPageTemplate } from "../components/setup-pages/SetupPageTemplate";
import { Introduction } from "../components/setup-pages/Introduction";
import { ContactData } from "../components/setup-pages/ContactData";
import { Consent } from "../components/setup-pages/Consent";
import { ReadyToStart } from "../components/setup-pages/ReadyToStart";
import { LoadingData } from "../components/setup-pages/LoadingData";
import { logout } from "../services/authService";
import { withMsal } from "@azure/msal-react";
import { setConsentConfirmed } from "../services/dashApiService";

class SetupBase extends Component {
	state = {
		page: 1,
		consentChecked: false,
		pageTransitionInProgress: false,
	};

	handleClickNext = () => {
		if (this.state.pageTransitionInProgress) {
			return;
		}

		this.setState({ pageTransitionInProgress: true });
		this.loadNextPage();
	};
	handleClickBack = () => {
		if (this.state.pageTransitionInProgress) {
			return;
		}

		this.setState({ pageTransitionInProgress: true });
		this.loadPrevPage();
	};

	handleConsentCheck = () => {
		this.setState({ consentChecked: !this.state.consentChecked });
	};

	loadNextPage = () => {
		const page = Math.min(5, this.state.page + 1);
		this.setState({ page, pageTransitionInProgress: false });
	};

	loadPrevPage = () => {
		const page = Math.max(0, this.state.page - 1);
		this.setState({ page, pageTransitionInProgress: false });
	};

	loadStartRoute = (msalInstance, account) => {
		//this.props.history.push("/");
		logout(this.props.msalContext.instance, this.props.msalContext.accounts[0]);
	};

	loadDashboardRoute = () => {
		this.props.history.push("/dashboard");
	};

	consentShowNextButton = () => {
		return this.state.consentChecked
			? () => {
					this.handleClickNext();
					setConsentConfirmed()
						.then(() => {
							// this.handleClickNext();
						})
						.catch((error) => {
							console.error(error);
							// toast.error(
							// 	"An error occurred confirming your consent, please try again",
							// 	{ toastId: toastConfig.toastIds.errSave }
							// );
						});
			  }
			: null;
	};

	render() {
		const { page, consentChecked } = this.state;
		const { userDetails } = this.props.location.state;

		if (page === 1) {
			return (
				<SetupPageTemplate
					headerDetails={{
						title: "Introduction",
						currentPage: 1,
						pageCount: 5,
					}}
					onClickNext={this.handleClickNext}
					onClickBack={this.loadStartRoute}
				>
					<Introduction />
				</SetupPageTemplate>
			);
		} else if (page === 2) {
			return (
				<SetupPageTemplate
					headerDetails={{
						title: "Contact data",
						currentPage: 2,
						pageCount: 5,
					}}
					onClickNext={this.handleClickNext}
					onClickBack={this.handleClickBack}
				>
					<ContactData userDetails={userDetails} />
				</SetupPageTemplate>
			);
		} else if (page === 3) {
			return (
				<SetupPageTemplate
					headerDetails={{
						title: "Consent",
						currentPage: 3,
						pageCount: 5,
					}}
					onClickNext={this.consentShowNextButton()}
					onClickBack={this.handleClickBack}
				>
					<Consent
						onConsentCheck={this.handleConsentCheck}
						checked={consentChecked}
					/>
				</SetupPageTemplate>
			);
		} else if (page === 4) {
			return (
				<>
					<SetupPageTemplate
						headerDetails={{
							title: "Ready to start",
							currentPage: 4,
							pageCount: 5,
						}}
						onClickNext={this.handleClickNext}
						onClickBack={this.handleClickBack}
					>
						<ReadyToStart />
					</SetupPageTemplate>
				</>
			);
		} else if (page === 5) {
			return (
				<>
					<SetupPageTemplate
						headerDetails={{
							title: "Loading",
							currentPage: 5,
							pageCount: 5,
						}}
					>
						<LoadingData onComplete={this.loadDashboardRoute} />
					</SetupPageTemplate>
				</>
			);
		}
	}
}

const Setup = withMsal(SetupBase);

export default Setup;
